import {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
} from '@/services/AdminService/AdminCourseManagementService';
import type { CourseSectionsService } from '../types';

export const adminCourseSectionsService: CourseSectionsService = {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
};
